import { Link, useLocation } from "react-router-dom";
import { classNames } from "../utils";
interface PaginationProps {
  totalCount: number;
  currentPage: number;
  pageSize: number;
  search: string;
  showDescription?: boolean;
  params?: { [key: string]: string };
}

const Pagination = (props: PaginationProps) => {
  const location = useLocation();
  const { totalCount, currentPage, pageSize, search, showDescription, params } =
    props;
  const totalPages = Math.ceil(totalCount / pageSize);
  const pageCount = [...Array(totalPages)];

  const paramsURL = (): string => {
    let url = "";
    if (params) {
      for (const [key, value] of Object.entries(params)) {
        url += `&${key}=${value}`;
      }
    }
    return url;
  };

  const center = [
      currentPage - 2,
      currentPage - 1,
      currentPage,
      currentPage + 1,
      currentPage + 2,
    ],
    filteredCenter: Array<string | number> = center.filter(
      (p) => p > 1 && p < totalPages
    ),
    includeThreeLeft = currentPage === 5,
    includeThreeRight = currentPage === totalPages - 4,
    includeLeftDots = currentPage > 5,
    includeRightDots = currentPage < totalPages - 4;

  if (includeThreeLeft) {
    filteredCenter.unshift(2);
  }
  if (includeThreeRight) {
    filteredCenter.push(totalPages - 1);
  }

  if (includeLeftDots) {
    filteredCenter.unshift("...");
  }
  if (includeRightDots) {
    filteredCenter.push("...");
  }
  const iterate = totalPages <= 1 ? [] : [1, ...filteredCenter, totalPages];
  return (
    <>
      {showDescription && (
        <div className="text-gray-600 pt-4">
          <p>
            Showing Page
            <span className="mx-2 font-semibold">
              {pageCount.length === 1 ? 1 : currentPage}
            </span>
            to
            <span className="mx-2 font-semibold">{totalPages - 1}</span>of
            <span className="mx-2 font-semibold">{totalCount}</span>results
          </p>
        </div>
      )}

      <div
        data-testid="pagination"
        className="flex flex-wrap text-xs mt-5	font-small"
      >
        {iterate.map((el, idx) =>
          typeof el !== "number" ? (
            <span
              className="flex justify-center items-center w-10 h-9 border bg-white shadow font-medium text-gray-600"
              key={`dots-${idx}`}
            >
              ...
            </span>
          ) : (
            <Link
              key={el}
              className={classNames(
                "flex justify-center items-center w-10 h-9 border bg-white shadow",
                "font-medium text-gray-600",
                currentPage === el ? "underline" : ""
              )}
              to={{
                search:
                  search !== ""
                    ? "search=" + search + "&page=" + el + paramsURL()
                    : "page=" + el + paramsURL(),
              }}
              state={location.state}
            >
              {el}
            </Link>
          )
        )}
      </div>
    </>
  );
};

export default Pagination;
